// Chave neumórfica — o trilho é um SULCO e o botão um disco convexo dentro
// dele. Receita calibrada no crm a partir da referência que o Cleverson achou
// (uiverse.io/teymr/massive-goat-92): o que faz o trilho ler como afundado não
// é a sombra interna, é o LÁBIO DE LUZ por fora, embaixo.
//
// Antes disto o fin não tinha chave nenhuma — os liga/desliga eram os ícones
// FiToggleLeft/FiToggleRight, que são desenho, não superfície: não afundam, não
// respondem ao clique e não pertencem à gramática do tema.
//
// REGRA: nunca usar `transform` aqui. É o `translate-x` do Tailwind que move o
// botão; uma regra neu com transform apagaria o translate e o botão pularia
// para fora do trilho (foi o bug que matou o clique das filipetas no crm).
export function NeuSwitch({ on, onClick, disabled, title, tone = 'primary' }: {
  // tinyint do MySQL chega como 0/1, nao como boolean — aceitar os dois e a
  // realidade deste codebase, coagir no call site seria ruido em toda linha.
  on: boolean | number
  onClick: () => void
  disabled?: boolean
  title?: string
  tone?: 'primary' | 'amber'
}) {
  // O trilho LIGADO carrega cor semântica, então a regra .neu-switch não define
  // background — quem pinta é esta classe.
  const ligado = !!on
  const onBg = tone === 'amber' ? 'bg-amber-500' : 'bg-primary'
  return (
    <button
      type="button"
      role="switch"
      aria-checked={ligado}
      disabled={disabled}
      title={title}
      onClick={onClick}
      className={`neu-switch relative inline-flex h-[18px] w-8 shrink-0 items-center rounded-full align-middle transition-colors disabled:opacity-40 disabled:cursor-not-allowed ${ligado ? onBg : 'neu-switch-off bg-secondary'}`}
    >
      <span
        className={`neu-knob block h-3.5 w-3.5 rounded-full bg-white shadow-sm transition-transform ${ligado ? 'translate-x-[16px]' : 'translate-x-[2px]'}`}
      />
    </button>
  )
}
